import { styled } from '@motrix/tokens'

export const BrandContainer = styled('div', {
  alignItems: 'center',
  boxSizing: 'border-box',
  defaultVariants: {
    size: 'md',
  },
  display: 'inline-flex',
  height: '100%',
  justifyContent: 'center',
  maxWidth: '120px',

  variants: {
    size: {
      lg: {
        height: '74px',
        width: 'auto',
      },
      md: {
        height: '34px',
        width: 'auto',
      },
      sm: {
        height: '80%',
        width: 'auto',
      },
    },
  },

  width: '100%',
})
